const Vue = require('vue')

Vue.component('ui-loading', {
    props: {
        text: {
            type: String,
            default: 'Carregando...'
        },
        state: {
            default: true
        },
        onlyBlock: {
            default: false
        },
        padding: {
            default: 0
        },
        big: {
            default: false
        }
    },
    data () {
        return {}
    },
    ready () {
    },
    template: `
        <div :class="{'big-loading': big}">
            <div v-if="state" :style="{'padding': padding}">
                <div class="text-center" v-if="!onlyBlock">
                    <div style="color: #777; text-shadow: 1px 1px rgba(255,255,255, .6)">
                        <i class="fa fa-spin fa-circle-o-notch" style="font-size: 30px; line-height: 30px;"></i>
                        <br />
                        {{ text }}
                    </div>
                </div>
            </div>
            <div v-if="!state">
                <slot></slot>
            </div>
        </div>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/ui/loading.js